/**
 * Active announcement slug. null = feature disabled.
 * Must match a key under announcement_modal in locales.
 */
export const ACTIVE_ANNOUNCEMENT_MESSAGE_VERSION: string | null =
  '2026May26_WireTransferServices';
